import React from "react"
import propTypes from "prop-types"

import Header from "../Header"
import Content from "../Content"

class Item extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isHidden: true
    }
  }

  componentDidMount() {
    const { isOpen } = this.props

    this.setState({ isHidden: !isOpen })
  }

  onSwitch = () => {
    const { isHidden } = this.state

    this.setState({
      isHidden: !isHidden
    })
  }

  render() {
    const { children } = this.props
    const { isHidden } = this.state

    const newChildren = React.Children.map(children, child => {
      let newChild = child

      if (child.type.name === Header.name) {
        newChild = React.cloneElement(child, { onClick: this.onSwitch })
      } else if (child.type.name === Content.name) {
        newChild = React.cloneElement(child, {
          elRef: content => {
            this.content = content
          }
        })
      }

      return newChild
    })

    return (
      <div
        className={`accordion_item ${isHidden ? "" : "accordion_item--active"}`}
      >
        {newChildren[0]}

        <div
          style={{
            height: isHidden
              ? 0
              : this.content
              ? this.content.clientHeight
              : "auto"
          }}
          className="accordion_container"
        >
          {newChildren[1]}
        </div>
      </div>
    )
  }
}

Item.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  isOpen: propTypes.bool
}

Item.defaultProps = {
  isOpen: false
}

export default Item
